export type SortType<Key> = {
    key: keyof Key;
    ascending: boolean;
};
